document.addEventListener('DOMContentLoaded' , () => {
    const headerSummary = document.querySelectorAll('.header__menu-item')

    headerSummary.forEach(summary => {
        if (!summary.nextElementSibling) return;

        megaMenuDirection(summary)

        summary.addEventListener('mouseenter',() => {
            summary.parentElement.setAttribute('open','')
        })
        summary.nextElementSibling.addEventListener('mouseenter',() => {
            summary.classList.add('header__menu-item--active')
            summary.parentElement.setAttribute('open','')
        })
        summary.addEventListener('mouseleave',() => {
            summary.parentElement.removeAttribute('open')
        })
        summary.nextElementSibling.addEventListener('mouseleave',() => {
            summary.classList.remove('header__menu-item--active')
            summary.parentElement.removeAttribute('open')
        })
    })

    window.addEventListener('scroll' , () => {
        headerSummary.forEach(summary => {
            megaMenuDirection(summary)
        })
    })
})

document.addEventListener('click',(e) => {
    const headerSummary = e.target.closest('.header__menu-item')

    if (headerSummary) {
        e.preventDefault()
        if (location.href != headerSummary.firstElementChild.href && location.href != headerSummary.href){
            if ( headerSummary.tagName.toLowerCase() == 'a') location.href = headerSummary.href
            else location.href = headerSummary.firstElementChild.href
        }
    }
})


function megaMenuDirection(summary) {
    if (!summary.nextElementSibling) return;
    let screenPosition = summary.getBoundingClientRect().top/window.innerHeight*100;

    summary.nextElementSibling.style.top = screenPosition < 50 ? '100%' : 'unset';
    summary.nextElementSibling.style.bottom = screenPosition < 50 ? 'unset' : '100%';
    summary.nextElementSibling.setAttribute('style', screenPosition < 50 ?
    `max-height: calc(100vh - ${summary.getBoundingClientRect().bottom}px); top: 100%; bottom: unset;` :
    `max-height: ${summary.getBoundingClientRect().top}px; top: unset; bottom: 100%;`)
}

